import React from 'react'

const ModelB = () => {
  return (
    <div>ModelB</div>
  )
}

export default ModelB